module.exports = __webpack_public_path__ + "static/pos_xero.0604377e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/za/integrations/images/xero/pos_xero.png
// module id = 1607
// module chunks = 106061173438730